import React from 'react';
import './ToastSuccess.css';

function ToastSuccess(props) {
    const title = props.title;
    const isToastSuccessVisible = props.isToastSuccessVisible;
    const setIsToastSuccessVisible = props.setIsToastSuccessVisible;

    let toastClass = 'toast-success--show';

    if(isToastSuccessVisible) {
        toastClass = 'toast-success--show';
    } else {
        toastClass = 'toast-success--hide';
    }

    const closeToast = () => {
        setIsToastSuccessVisible(false);
    }

    return (
        <div className={toastClass}>
            <div className="title-bar">
                <div className="toast-upper-left"></div>
                <div className="toast-success">{title}</div>
                <div className="toast-close-button" onClick={closeToast}>X</div>
            </div>      
            <div className="toast-success__message">
                <span>{props.message}</span>
            </div>
        </div>
    );
}

export default ToastSuccess;